import * as React from 'react';
import { useTranslation } from 'react-i18next';
import MaterialTable from '../../MaterialTable';
import { useTransportToWarehouseColumns } from '../../../hooks/useColumns';
import { useTransportToWarehouse } from '../../../hooks/useTransportToWarehouse';
import { EditIcon } from '../../atoms/Icons';
import FullScreenDialog from '../../molecules/FullScreenDialog';
import TransportToWarehouseForm from './TransportToWarehouseForm';
var TransportToWarehouseTable = function (_a) {
    var _b;
    var offerList = _a.offerList;
    var t = useTranslation().t;
    var _c = React.useState(), editingItem = _c[0], setEditingItem = _c[1];
    var TransportToWarehouseColumns = useTransportToWarehouseColumns();
    var _d = useTransportToWarehouse(offerList.id), transportToWarehouses = _d.transportToWarehouses, reload = _d.reload, loading = _d.loading;
    var columns = React.useMemo(function () { return [
        TransportToWarehouseColumns.warehouseName,
        TransportToWarehouseColumns.status,
        TransportToWarehouseColumns.importTaxRate,
        TransportToWarehouseColumns.exportedAt,
        TransportToWarehouseColumns.importedAt,
        TransportToWarehouseColumns.note,
        TransportToWarehouseColumns.trackingUrl,
        TransportToWarehouseColumns.simulationShippingFeeUnitPrice,
        TransportToWarehouseColumns.simulationMiscFeeUnitPrice,
        TransportToWarehouseColumns.simulationTaxedMiscFeeUnitPrice,
        TransportToWarehouseColumns.fixedShippingFeeUnitPrice,
        TransportToWarehouseColumns.fixedMiscFeeUnitPrice,
        TransportToWarehouseColumns.fixedTaxedMiscFeeUnitPrice,
        TransportToWarehouseColumns.exportMoistureContent,
        TransportToWarehouseColumns.exportWaterActivity,
        TransportToWarehouseColumns.importMoistureContent,
        TransportToWarehouseColumns.importWaterActivity,
        TransportToWarehouseColumns.estimatedDeliveryPeriodYear,
        TransportToWarehouseColumns.estimatedDeliveryPeriodMonth,
        TransportToWarehouseColumns.estimatedDeliveryPeriodMonthPart,
        TransportToWarehouseColumns.beansPaidAt,
        TransportToWarehouseColumns.miscFeesPaidAt,
        TransportToWarehouseColumns.shippingFeePaidAt,
        TransportToWarehouseColumns.importTaxPaidAt,
    ]; }, [TransportToWarehouseColumns]);
    var actions = React.useMemo(function () { return [
        {
            icon: function () { return React.createElement(EditIcon, null); },
            tooltip: 'Edit',
            onClick: function (event, row) { return setEditingItem(row); },
        },
    ]; }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(MaterialTable, { title: t('pages.offerList.transportToWarehouseTable'), model: "transportToWarehouse", isLoading: loading, columns: columns, data: transportToWarehouses, actions: actions }),
        React.createElement(FullScreenDialog, { title: ((_b = editingItem === null || editingItem === void 0 ? void 0 : editingItem.warehouse) === null || _b === void 0 ? void 0 : _b.name) || '', open: Boolean(editingItem), onClose: function () { return setEditingItem(undefined); } }, editingItem && (React.createElement(TransportToWarehouseForm, { offerList: offerList, transportToWarehouse: editingItem, onUpdated: function (transportToWarehouse) {
                setEditingItem(transportToWarehouse);
                reload();
            } })))));
};
export default TransportToWarehouseTable;
